import React from 'react';
import './TimerBar.css';

interface TimerBarProps {
  timeRemaining: number;
  timeLimit: number;
  questionNumber?: number;
  totalQuestions?: number;
  warningThreshold?: number; // seconds
  /** When false, hide the "Xs" counter (player screens - avoids sync mismatch with host) */
  showTimeCounter?: boolean;
}

const TimerBar: React.FC<TimerBarProps> = ({
  timeRemaining,
  timeLimit,
  questionNumber,
  totalQuestions,
  warningThreshold = 5,
  showTimeCounter = true,
}) => {
  const timeSeconds = Math.ceil(timeRemaining / 1000);
  const progress = (timeRemaining / timeLimit) * 100;
  const isWarning = timeSeconds <= warningThreshold;
  const hasNumbers = typeof questionNumber === 'number' && typeof totalQuestions === 'number';
  const questionLabel = hasNumbers
    ? `Question ${questionNumber} of ${totalQuestions}`
    : 'Question — of —';

  return (
    <div className="timer-bar" style={{ width: '100%', boxSizing: 'border-box' }}>
      <div className="question-number" style={{
        display: 'flex',
        justifyContent: 'space-between',
        alignItems: 'center',
        marginBottom: '1rem',
        width: '100%',
      }}>
        <span>{questionLabel}</span>
        {showTimeCounter && (
          <div
            className={`timer timer-bar__time ${isWarning ? 'timer-bar__time--warning' : ''}`}
            style={{ fontSize: '1.5rem', margin: 0 }}
          >
            {timeSeconds}s
          </div>
        )}
      </div>

      <div
        className="timer-bar__track"
        style={{
          width: '100%',
          height: '10px',
          borderRadius: '5px',
          overflow: 'hidden',
          marginBottom: '1.5rem',
          boxSizing: 'border-box',
        }}
      >
        <div
          className={isWarning ? 'timer-bar__slider-fill--warning' : ''}
          style={{
            width: `${progress}%`,
            height: '100%',
            background: isWarning ? 'var(--color-error)' : 'var(--color-primary)',
            transition: 'width 0.1s linear',
          }}
        />
      </div>
    </div>
  );
};

export default TimerBar;

